export const tr = {
    contains: 'içeriyor',
    'day-placeholder': 'gg',
    'incorrect-date': 'Yanlış tarih',
    'month-placeholder': 'aa',
    'not-contains': 'içermiyor',
    'year-placeholder': 'yyyy'
};
